// src\themes\tolica\components\TextWidget.tsx
import { Heading } from "@/components/ui/Heading";
import { loadThemeComponent } from "@/core/config/theme-component-loader";
import Link from "next/link";
const CustomButton = loadThemeComponent("CustomButton")


type TextItem = {
    title?: string;
    description?: string;
    width?: string;
    buttonContent?: string;
    link?: string;
};

type GlobalWidgetItem = {
    direction?: 'left' | 'center' | 'right';
    items?: TextItem[];
    textItems?: TextItem[];
    width?: string;
};

export default function TextWidget({ data, isHome = false }: { data: GlobalWidgetItem; isHome?: boolean }) {

    const textAlign = data.direction === 'center' ? 'text-center' : data.direction === 'right' ? 'text-start' : 'text-end';
    const itemsAlign = data.direction === 'center' ? 'items-center' : data.direction === 'right' ? 'items-start' : 'items-end';
    const widthMap: Record<string, string> = {
        '1/1': 'col-span-12',
        '1/2': 'col-span-12 md:col-span-6',
        '1/3': 'col-span-12 md:col-span-4',
        '1/4': 'col-span-12 md:col-span-3',
        '2/3': 'col-span-12 md:col-span-8',
        '3/4': 'col-span-12 md:col-span-9',
    };

    const widgetWidth = widthMap[data.width || '1/1'];

    // فقط وقتی تمام‌عرضه (۱/۱) و توی صفحه اصلیه فاصله‌ی کناری می‌گیره؛ برای
    // عرض‌های جزئی روی grid gap حساب می‌شه، وگرنه فاصله‌ی بین دو ویجت کنار هم
    // غیرعادی زیاد می‌شه.
    const homePadding = isHome && (data.width === '1/1' || !data.width) ? 'px-4 sm:px-6 lg:px-12' : '';

    return (
        <div className={`${widgetWidth} m-auto justify-center flex flex-col space-y-7 h-full w-full ${textAlign} ${homePadding}`}>
            {data.items?.map((item, index) => (
                <div key={index} className={`justify-center flex flex-col ${itemsAlign}`}>
                    {item.title && <Heading level={2}>{item.title}</Heading>}
                    {item.description && <p className="text-primary-600 text-sm mt-2 whitespace-pre-line leading-6">{item.description}</p>}
                    {item.buttonContent && item.link && (
                        <div className={`w-fit ${data.direction === 'center' ? 'mx-auto' : ''}`}>
                            <CustomButton asChild className="mt-4">
                                <Link href={item.link}>
                                    {item.buttonContent}
                                </Link>
                            </CustomButton>
                        </div>
                    )}

                </div>
            ))}

        </div >
    );
}